import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      about_us: "About us",
      location: "Location",
      dj_booking: "DJ Booking",
      gallery: "Gallery",
      profile: "Profile",
      login: "Login",
      company: "Company",
      pending: "Pending",
      events: "Events",
      date_of_birth: "Date of Birth",
      save_changes: "Save Changes",
      cart: "Cart",
      add_to_cart_button: "Get Ticket",
      expand: "Expand",
      socials: "Socials",
      language:"Language",
      rejected: "Rejected",
      scan_qr_code: "Scan QR",
      tickets: "Tickets",
      collapse_my_tickets: "Collapse",
      rentals: "Our Space",
      currency: "$",
      djs: "DJs",
      last_name: "Last Name",
      price: "Price",
      starting_soon: "Next Event",
      in_session: "Happening Now",
      my_tickets: "My Tickets",
      ended: "Ended",
      main_stage: "Maker Stage",
      space_stage: "Space Stage",
      stage:"Stage",
      default_cover_art: "Default Cover Art",
      no_stage_data_available: "No stage data available.",
      in_session_image_alt: "In Session",
      no_events_found: "No events found",
      next_up: "Next Up",
      view_more: "View More",
      coming_soon: "Coming Soon",
      past_events: "Past Events",
      rental_title:"Host Your Private Celebration at Makerspace",
      rental_info_short:"Unlock the potential of our dynamic two-floor venue in the heart of Tbilisi. Perfect for corporate functions or private celebrations, our space—with its dance stage, chill-out zones, and versatile bars—is designed to leave a lasting impression. Ready to make your event unforgettable?",
      "rental_info_intro": "Looking for the perfect venue to celebrate your special occasion?",
"rental_info_venue": "<strong>Makerspace</strong> in the heart of Tbilisi is your ultimate destination for unforgettable private events.",
"rental_info_features": "With <strong>two stylish floors</strong>, <strong>fully stocked bars</strong>, <strong>two DJ stages</strong>, and a <strong>cozy garden bar</strong>, we offer a unique and flexible space for all types of celebrations—whether it’s a birthday, corporate party, anniversary, or any excuse to gather and have fun.",
"rental_info_offer_heading": "<strong>What We Offer:</strong>",
"rental_info_offer_1": "<strong>Capacity for up to 400 guests</strong>",
"rental_info_offer_2": "<strong>Customizable spaces</strong> – choose the full venue or just one floor with the garden bar for more intimate events",
"rental_info_offer_3": "<strong>Top-quality sound and lighting</strong> with professional DJ setup included",
"rental_info_offer_4": "<strong>Drink coupon system</strong> – Cocktails, Shots, Mixed drinks, and more, tailored to your needs",
"rental_info_offer_5": "<strong>Flexible decoration and lighting options</strong> to match your theme",
"rental_info_offer_6": "<strong>Professional staff</strong> to ensure smooth operation from start to finish",
"rental_info_closer": "Whether you want an all-night dance party or a chill cocktail evening with close friends, <strong>Makerspace</strong> adapts to your vision.",
"rental_info_footer": "Let us know your ideas, and we'll help make them happen.",
      rental_action:"Book Now",
      dj_booking_title: "Take the Stage at Makerspace",
      dj_booking_info: "Are you ready to showcase your talent at one of the most dynamic venues in Tbilisi? Whether you're an emerging artist or a seasoned DJ, our space—with its immersive sound system, energetic dance floor, and vibrant crowd—is the perfect platform to make your mark. Ready to electrify the night?",
      dj_booking_action: "Book Now",
      "about_me_1": "<strong>Makerspace</strong> is more than just a nightclub—it's a creative hub where music, culture, and community collide.",
"about_me_2": "Located in the heart of <strong>Tbilisi’s Gudiashvili Square</strong>, Makerspace blends colorful interior with cutting-edge sound and lighting to create a one-of-a-kind atmosphere for nightlife lovers, artists, and event organizers.",
"about_me_3": "Since opening, we've proudly hosted <strong>over 400 events</strong> and welcomed <strong>more than 700 DJs</strong> from around the world, turning Makerspace into a true landmark in the region’s electronic music scene.",
"about_me_4": "Spread over <strong>two floors</strong>, the venue features:",
"about_me_list_1": " <strong>Two dynamic DJ stages</strong>",
"about_me_list_2": " <strong>Top quality Sound System</strong>",
"about_me_list_3": " <strong>Three fully equipped bars</strong>",
"about_me_list_4": " <strong>Cocktails, Mixed Drinks, Shots…</strong>",
"about_me_list_5": " <strong>A cozy and versatile Garden Bar</strong>",
"about_me_list_6": " <strong>Space to host up to 400 guests</strong>",
"about_me_list_7": " <strong>Professional Staff</strong>",
"about_me_5": "By day, it’s a canvas for private and corporate events. By night, it transforms into the <strong>pulse of Tbilisi’s electronic culture</strong>, where local and international talent bring the night to life.",
"about_me_6": "Whether you're here to celebrate, collaborate, or just lose yourself in the music, Makerspace is your space to make it happen!",
 about_me_action:"Gallery",
      friday: "Friday",
      saturday: "Saturday",
      opening_hours: "Opening Hours",
      address_about: "Lado Gudiashvili Square, Tbilisi 0162, Georgia",
      contact: "Contact",
      gallery_text: "So many events together, so many shared memories. ❤",
      gallery_title: "Makerspace Gallery",
      gallery_action: "View More",
      rental_form_title: "Ready for the next party?",
      rental_form_description: "Fill out the form to get in touch with our team and discuss your event requirements.",
      rental_form_name: "Your Name",
      rental_form_email: "Your Email",
      rental_form_event_description: "Tell us about your event",
      rental_form_submit: "Submit",
      rental_form_thank_you: "We look forward to helping you create a memorable celebration at Makerspace!",
      rental_form_success: "Your message has been successfully sent. We will contact you soon!",
      rental_form_submitting:"Submitting...",
      contact_info_sub:"For direct inquiries",
      contact_info_sub2:"For DJ bookings, please reach out to us at:",
      contact_email_sub:" or email us at: ",
      dj_perform: "Perform at Makerspace",
      dj_perform_info:"Hey there!\n\nWe’re always on the lookout for fresh sounds and bold selectors to join our lineup. Whether you’re a seasoned pro or an emerging talent—if your beats move people, we want to hear from you.\n\nOur stages are powered by VOID Acoustics sound systems, Pioneer CDJ-3000 decks, and Allen & Heath Xone:96 mixers.\n\nThe Main Stage is all about high-energy tech-house and minimal, while the Space Stage delivers more melodic grooves and disco house vibes.\n\nReady to bring your sound to Makerspace? Fill out the form, and we’ll be in touch soon.",
      dj_perform_title: "Wanna introduce yourself?",
      dj_perform_text: "Ready to take the stage? Submit your details below, and our team will get in touch ASAP!",
      dj_perform_see_you_on_dancefloor: "See you at Makerspace!",
      dj_form_full_name: "Full Name",
      dj_form_stage_name: "Stage Name",
      dj_form_social: "Social Network Link",
      dj_form_music: "Music Platform Link",
      dj_form_motivation: "Motivation",
      dj_form_submit: "Submit",
      dj_form_thank_you: "Thank you for your interest!",
      dj_form_success: "Your message has been successfully sent. We will contact you soon!",
      dj_form_submitting:"Submitting...",
      dj_form_error:"An error occurred while submitting the form. Please try again later.",
      dj_form_name_error:"Please enter your full name.",
      dj_form_stage_name_error:"Please enter your stage name.",
      dj_form_social_error:"Please enter your social network link.",
      dj_form_music_error:"Please enter your music platform link.",
      dj_form_motivation_error:"Please enter your motivation.",
      dj_form_submit_error:"An error occurred while submitting the form. Please try again later.",
      "weekdays": {
        "monday": "Monday",
        "tuesday": "Tuesday",
        "wednesday": "Wednesday",
        "thursday": "Thursday",
        "friday": "Friday",
        "saturday": "Saturday",
        "sunday": "Sunday"
      },
      "months": {
    "january": "January",
    "february": "February",
    "march": "March",
    "april": "April",
    "may": "May",
    "june": "June",
    "july": "July",
    "august": "August",
    "september": "September",
    "october": "October",
    "november": "November",
    "december": "December"
  }, 
  starts_at: "starts at",
  "loading_profile": "Loading profile...",
  "profile_not_loaded": "Could not load profile data.",
  "welcome": "Welcome, {{name}}!",
  "verified": "Verified",
  "rejected": "Rejected",
  "pending": "Pending",
  "name": "Name",
  "email": "Email",
  "register": "Register",
  "phone": "Phone",
  "country": "Country",
  "personal_number": "ID/Passport Number",
  "birthdate": "Birthdate",
  "social_media_link": "Social Media Link",
  "n_a": "N/A",
  "logout": "Logout",
    "error":{
      "bad_request":"Bad Request",
      "invalid_credentials":"Invalid credentials",
      "no_permission":"You don’t have permission to perform this action",
      "resource_not_found":"Resource not found",
      "server_error":"Server error",
      "network_error":"Network error",
      "generic":"Something went wrong",
      "fetching_countries":"Fetching countries",
      "email_exists":"Email already exists",
    },
    validation:{
      "email_required":"Email is required",
      "password_required":"Password is required",
      "first_name_required":"First Name is required",
      "last_name_required":"Last Name is required",
      "phone_required":"Phone is required",
      "country_required":"Country is required",
      "confirm_password_required":"Confirm Password is required",
      "personal_number_required":"ID/Passport number is required",
      "birthdate_required":"Birthdate is required",
      "social_media_required":"Social Media Link is required",
      "password_mismatch":"Passwords do not match",
      "password_complexity" :"Password must meet the complexity requirements",
      "social_media_format":"Social Media Link must be a valid URL",
      "age_requirement" :"You must be at least 18 years old to use this service",
      "personal_number_format":"ID must be a valid Georgian ID number",
      "personal_number_format_non_georgian": "ID/Passport must be a valid ID number",
      "invalid_email":"Invalid email",
      "phone_format_invalid":"Invalid phone number",
      "social_media_invalid_url": "Invalid Social Media Link",
    },
    "success":{
      "registration":"Registration successful! Redirecting to login...",
    },
  
    "auth":{
      "login_title":"Login",
      "email_lable":"Email",
      "public_profile_info":"Your profile should be set to public",
      "email_placeholder":"user@example.com",
      "password_label":"Password",
      "sign_in":"Sign In",
      "no_account":"Don't have an account?",
      "register_here":"Register here",
      "forgot_password":"Forgot Password",
      "reset_here":"Reset here",
      "first_name":"First Name",
      "last_name":"Last Name",
      "confirm_password":"Confirm Password",
      "personal_number":"ID/Passport Number",
      "birthdate":"Birthdate",
      "social_media_link":"Social Media Link",
      "country":"Country",
      "select_country":"Select Country",
      "phone_number":"Phone Number",
      "select_code":"Select Code",
      "phone_placeholder":"+995 599 12 34 56",
      "social_media_profile_link":"Profile should be public",
      "register":"Register",
      "already_have_account":"Already have an account?",
      "login_here":"Login here",
      "reset_password":"Reset Password",
      "remembered":"Remembered?",
      "passwords_match" :"Passwords match",
      "passwords_do_not_match":"Passwords do not match",
      "personal_number_placeholder_georgia": "Enter your ID/passport number",
      "auth.personal_number_placeholder_non_georgia": "Enter your passport/ID number"
    },
    "password_rules":{
      "length":"Password must be at least 8 characters long",
      "uppercase":"Password must contain at least one uppercase letter",
      "lowercase":"Password must contain at least one lowercase letter",
      "special":"Password must contain at least one special character",
  },
  "cart":{
    "item_price_label":"Price",
    "cart": "Cart",
    "cart_empty": "Your cart is empty",
    "order_summary": "Order Summary",
    "subtotal": "Subtotal",
    "estimated_total": "Estimated Total",
    "checkout": "Checkout",
    "discount": "Discount",
    "update_cart": "Update Cart",
    "enter_discount_code": "Enter Discount Code",
    "terms_and_conditions": "By proceeding, you agree to our",
    "terms_and_conditions_2":"Terms and Conditions",  

  },
  "QRscan":{
    "ticket_qr_scanner": "Ticket QR Scanner",
    "select_decision": "Select Decision",
    "accept": "Accept",
    "reject": "Reject",
    "scanning_for_qr_code": "Scanning for QR code...",
    "scan_again": "Scan Again",
    "fetching_user_info": "Fetching user information...",
    "accepted": "Accepted",
    "rejected": "Rejected",

  },
  "status": {
    "verified": "Verified",
    "rejected": "Rejected",
    "pending": "Pending",
    "unverified": "Not Verified",
    "check_later": "Check Later"
  }
}
 },
  ka: {
    translation: {
      about_us: "ჩვენს შესახებ",
      location: "ლოკაცია",
      dj_booking: "DJ-ები",
      gallery: "გალერეა",
      profile: "პროფილი",
      save_changes: "შენახვა",
      currency:"₾",
      login: "შესვლა",
      company: "კომპანია",
      verified: "ვერიფიცირებული",
      pending: "დაელოდეთ ვერიფიკაციას",
      events: "ივენთები",
      price: "ფასი",
      language:"ენა",
      socials: "შემოგვიერთდი",
      rejected: "არ ხართ ვერიფიცირებული",
      rentals: "ჩვენი სივრცე",
      djs: "DJ-ები",
      tickets: "ბილეთები",
      first_name: "სახელი",
      add_to_cart_button: "ბილეთის დამატება",
      last_name: "გვარი",
      starting_soon: "შემდეგი ივენთი",  
      in_session: "მიმდინარე ივენთი",
      ended: "დასრულებული",
      date_of_birth: "დაბადების თარიღი",
      scan_qr_code: "QR სკანი",
      stage: "",
      register: "რეგისტრაცია",
      my_tickets: "ჩემი ბილეთები",
      collapse_my_tickets: "დახურვა",
      main_stage: "Main Stage",
      space_stage: "Space Stage",
      default_cover_art: "ნაგულისხმებული სურათი",
      no_stage_data_available: "სცენის მონაცემები არ არის ხელმისაწვდომი.",
      in_session_image_alt: "გადმოყოლილი",
      no_events_found: "ივენთები არ მოიძებნა",
      next_up: "მომდევნო ივენთები",
      view_more: "ყველა ივენთი",
      coming_soon: "შემდეგი ივენთები",
      past_events: "გასული ივენთები",
      rental_title:"მოაწყე წვეულება მეიქერსფეისში",
      rental_info_short:"მოაწყე ღონისძიება თბილისის შუაგულში, ჩვენთან ულამაზეს გარემოში, შენ შეგიძლია დახურული ივენთების მოწყობა, კორპორატიული წვეულებების გამართვა და რაც მთავარია კვირის ბოლოს მეგობრებთან ერთად დაუვიწყარი გართობა. ამ ყველაფერში დაგეხმარებათ  ჩვენი ორი საცეკვაო სცენა, მრავალფეროვანი ბარი, VOID ის აუდიო სისტემა და განსატვირთი ზონები, სადაც შერწყმულია თანამედროვე ხელოვნებისა და ელექტრონული კოლაბორაციისა და ჯავშნისთვის დაგვიკავშირდით მეილზე.",
        "rental_info_intro": "ეძებთ იდეალურ ადგილს ივენთის აღსანიშნავად?",
        "rental_info_venue": "<strong>მეიქერსფეისი</strong>, თბილისის შუაგულში, დაგეხმარება დაუვიწყარი კერძო ღონისძიებებისთვის ჩატარებაში.",
        "rental_info_features": " <strong>ორი ელეგანტური სთეიჯით</strong>, <strong>სრულიად აღჭურვილი ბარები</strong>, <strong>ორი DJ სცენა</strong> და <strong>მყუდრო ეზოს ბარი</strong> გთავაზობთ უნიკალურ სივრცეს ნებისმიერი ტიპის ზეიმისთვის — იქნება ეს დაბადების დღე, კორპორატიული წვეულება, საიუბილეო შეკრება თუ უბრალოდ მეგობრებთან ერთად გართობა.",
        "rental_info_offer_heading": "<strong>რას გთავაზობთ ჩვენ:</strong>",
        "rental_info_offer_1": "<strong>400-მდე სტუმრის მისაღები სივრცე</strong>",
        "rental_info_offer_2": "<strong>მორგებადი სივრცეები</strong> – აირჩიეთ მთელი სივრცე ან მხოლოდ ერთი სართული ეზოს ბართან უფრო თბილი ღონისძიებისთვის",
        "rental_info_offer_3": "<strong>უმაღლესი ხარისხის ხმის და განათების სისტემა</strong> პროფესიონალური DJ მოწყობილობით",
        "rental_info_offer_4": "<strong>სასმელის კუპონების სისტემა</strong> – კოქტეილები, შოტები, მიქს სასმელები და სხვა — მორგებული თქვენს კომფორტზე",
        "rental_info_offer_5": "<strong>სხვადასვა ტიპის დეკორაციის და განათების ვარიანტები</strong>",
        "rental_info_offer_6": "<strong>პროფესიონალური პერსონალი</strong> უზრუნველყოფს ღონისძიების შეუფერხებელ მიმდინარეობას დასაწყისიდან დასრულებამდე",
        "rental_info_closer": "თუ გსურთ მთელი ღამის ცეკვის წვეულება ან მშვიდი კოქტეილის საღამო ახლო მეგობრებთან ერთად, <strong>მეიქერსფეისი</strong> მოერგება თქვენს ხედვას.",
        "rental_info_footer": "გაგვიზიარეთ თქვენი იდეები, და ჩვენ დაგეხმარებით მათ განხორციელებაში.",
      rental_action:"დაჯავშნა",
      dj_booking_title: "დაუკარი მეიქერსფეისში",
      dj_booking_info:"მზად ხარ, რომ გამოაჩინო შენი ნიჭი, ყველაზე დინამიურ გარემოში? თუ ხარ გამოცდილი DJ,ან გსურს საზოგადოებამ შენი მუსიკა კარგად გაიცნოს, გელოდებით ჩვენს სივრცეში, სადაც დაგხვდება  საუკეთესო ხმის სისტემები, ენერგიული საცეკვაო მოედანი და უმაგრესი მსმენელი. თუ მზად ხარ, რომ შენი კვალი დატოვო, თანამედროვე ელექტრონულ მუსიკაში  შეავსე ფორმა ან მოგვწერე მეილზე.",
      dj_booking_action:"დაჯავშნა",
     "about_me_1": "<strong>მეიქერსფეისი</strong> მარტო ღამის კლუბი არაა — ეს არის კრეატიული სივრცე სადაც ელექტრონული მუსიკა, თანამედროვე კულტურა და კარგი საზოგადოება იყრის თავს.",
"about_me_2": "მეიქერსფეისი <strong>თბილისის გულში, გუდიაშვილი მოედანზე</strong> მდებარეობს და აერთიანებს უალამაზეს ფერად ინტერიერს, უმაღლესი ხარისხის აკუსტიკურ სისტემას და განათებას, რომ შექმნას უნიკალური ატმოსფერო ღამის ცხოვრების მოყვარულებისთვის, არტისტებისთვის და ივენთების ორგანიზატორებისთვის.",
"about_me_3": "გახსნის დღიდან, ვუმასპინძლეთ <strong>400-მდე ივენთს</strong> და <strong>700-ზე მეტ ქართველ და უცხოელ არტისტს</strong>, რითიც წარუშლელი კვალს ვტოვებთ რეგიონის ელექტრონული მუსიკის სცენის განვითარებაში.",
"about_me_4": "<strong>ორ სართულზე</strong> განთავსებული ვენიუში დაგხვდებათ:",
"about_me_list_1": " <strong>400 ადამიანზე გათვლილი სივრცე</strong>",
"about_me_list_2": " <strong>ორი DJ სთეიჯი</strong>",
"about_me_list_3": " <strong>საუკეთესო აკუსტიკური სისტემა და DJ ტექნიკა</strong>",
"about_me_list_4": " <strong>სამი პროფესიონალი ბარი</strong>",
"about_me_list_5": " <strong>კოქტეილები, მიქს დრინქები, სუფთა სახის სასმელები...</strong>",
"about_me_list_6": " <strong>მყუდრო და ლამაზი ეზო</strong>",
"about_me_list_7": " <strong>პროფესიონალი პერსონალი</strong>",
"about_me_5": "დღისით <strong>მეიქერსფეისი</strong> პირადი და კორპორატიული წვეულებების სივრცეა. ღამით კი <strong>ელექტრონული მუსიკის მოსმენისა და სოციალიზაციის ტოპ ადგილია</strong>, სადაც ქართველი და უცხოელი არტისტები დაუვიწყარ ღამეებს ქმნიან.",
"about_me_6": "არ აქვს მნიშვნელობა რამეს აღნიშნავთ, კოლაბორაცია გსურთ, თუ უბრალოდ მუსიკაში დაკარგვა — <strong>მეიქერსფეისი</strong> სწორედ ის ადგილია სადაც ეს ხდება.",
  about_me_action:"გალერეა",
      friday: "პარასკევი",
      saturday: "შაბათი",
      opening_hours: "სამუშაო საათები",
      address_about: "ლადო გუდიაშვილის მოედანი, თბილისი 0162, საქართველო",
      contact: "კონტაქტი",
      gallery_text: "უამრავი ივენთი და მომენტი ერთად — უამრავი მოგონებებით. ❤",
      gallery_title: "მეიქერსფეისის გალერეა",
      rental_form_title: "გსურთ ჩვენთან სივრცის ქირაობა?",
      rental_form_description: "შეავსეთ ფორმა, რომ დაგვიკავშირდეთ და განვიხილოთ თქვენი ღონისძიების მოთხოვნები. ველით თქვენს შეტყობინებას!",
      rental_form_name: "თქვენი სახელი",
      rental_form_email: "თქვენი ელფოსტა",
      rental_form_event_description: "გვითხარით თქვენი ღონისძიების შესახებ",
      rental_form_submit: "გაგზავნა",
      rental_form_thank_you: "გმადლობთ თქვენი ინტერესისთვის!",
      rental_form_success: "თქვენი შეტყობინება წარმატებით გაიგზავნა. მალე დაგიკავშირდებით!",
      rental_form_submitting:"მიმდინარეობს გაგზავნა...",
      contact_info_sub:"დასაკონტაქტებლად დაგვიკავშირდით ნომერზე:",
      contact_info_sub2:"DJ-ების დაჯავშნისთვის მოგვწერეთ:",
      contact_email_sub:" ან მოგვწერეთ: ",
      dj_perform: "დაუკარი Makerspace-ში",
      dj_perform_info:"Makerspace გთავაზობთ ყველაზე გამორჩეულ მუსიკალურ სცენას თბილისში. Makerspace არის ადგილი, სადაც ახალგაზრდა და გამოცდილი DJ-ები აქვთ შესაძლებლობა აჩვენონ თავიანთო ნიჭი. თუ თქვენ ხართ DJ, რომელიც უკრავს როგორც თანამედროვე მუსიკას ასევე Underground მუსიკას, ჩვენი სივრცე არის იდეალური ადგილი თქვენი გამოსვლისთვის.",
      dj_perform_title: "გსურთ სცენაზე გამოსვლა?",
      dj_perform_text: "მზად ხართ Makerspace-ის სცენაზე გამოსასვლელად? შეავსეთ ქვემოთ მოცემული ფორმა და ჩვენი გუნდი დაგიკავშირდებათ თქვენი სეტის განხილვისთვის. ერთად გავხადოთ თქვენი გამოსვლა დაუვიწყარი!",
      dj_perform_see_you_on_dancefloor: "შევხვდებით სცენაზე!",
      dj_form_full_name: "სრული სახელი",
      dj_form_stage_name: "სცენის სახელი",
      dj_form_social: "სოციალური ქსელის ბმული",
      dj_form_music: "მუსიკალური პლატფორმის ბმული",
      dj_form_motivation: "მოტივაცია",
      dj_form_submit: "გაგზავნა",
      dj_form_thank_you: "გმადლობთ თქვენი ინტერესისთვის!",
      dj_form_success: "თქვენი შეტყობინება წარმატებით გაიგზავნა. მალე დაგიკავშირდებით!",
      dj_form_submitting:"მიმდინარეობს გაგზავნა...",
      dj_form_error:"შეტყობინების გაგზავნისას მოხდა შეცდომა. გთხოვთ, სცადოთ მოგვიანებით.",
      dj_form_name_error:"გთხოვთ, შეიყვანოთ თქვენი სრული სახელი.",
      dj_form_stage_name_error:"გთხოვთ, შეიყვანოთ თქვენი სცენის სახელი.",
      dj_form_social_error:"გთხოვთ, შეიყვანოთ თქვენი სოციალური ქსელის ბმული.",
      dj_form_music_error:"გთხოვთ, შეიყვანოთ თქვენი მუსიკალური პლატფორმის ბმული.",
      dj_form_motivation_error:"გთხოვთ, შეიყვანოთ თქვენი მოტივაცია.",
      dj_form_submit_error:"შეტყობინების გაგზავნისას მოხდა შეცდომა. გთხოვთ, სცადოთ მოგვიანებით.",
      "weekdays": {
        "monday": "ორშაბათი",
        "tuesday": "სამშაბათი",
        "wednesday": "ოთხშაბათი",
        "thursday": "ხუთშაბათი",
        "friday": "პარასკევი",
        "saturday": "შაბათი",
        "sunday": "კვირა"        
      },
      "months": {
        "january": "იანვარი",
        "february": "თებერვალი",
        "march": "მარტი",
        "april": "აპრილი",
        "may": "მაისი",
        "june": "ივნისი",
        "july": "ივლისი",
        "august": "აგვისტო",
        "september": "სექტემბერი",
        "october": "ოქტომბერი",
        "november": "ნოემბერი",
        "december": "დეკემბერი"
      },
      starts_at: "დაწყების დრო",
      "loading_profile": "მიმდინარეობს პროფილის ატვირთვა...",
      "profile_not_loaded": "პროფილის მონაცემების ატვირთვა ვერ მოხერხდა.",
      "welcome": "კეთილი იყოს თქვენი მობრძანება, {{name}}!",
      "profile": "პროფილი",
      "profile_picture": "პროფილის სურათი",
      "edit_profile": "პროფილის რედაქტირება",
      "save_changes": "შენახვა",
      "cancel": "გაუქმება",
      "profile_updated": "პროფილი წარმატებით განახლდა.",
      "profile_update_failed": "პროფილის განახლება ვერ მოხერხდა.",
      "name": "სახელი",
      "email": "ელფოსტა",
      "password": "პაროლი",
      "phone": "ტელეფონი",
      "address": "მისამართი",
      "social_media_link": "სოციალური მედიის ბმული",

      "birthdate": "დაბადების თარიღი",
      "personal_number": "პირადი ნომერი",
      "confirm_password": "დაადასტურეთ პაროლი",
      "current_password": "მიმდინარე პაროლი",
      "new_password": "ახალი პაროლი",
      "confirm_new_password": "დაადასტურეთ ახალი პაროლი",
      "update_password": "პაროლის განახლება",
      "password_updated": "პაროლი წარმატებით განახლდა.",
      "password_update_failed": "პაროლის განახლება ვერ მოხერხდა.",
      "event_details": "ივენთის დეტალები",
      "logout": "გამოსვლა",
      "error":{
        "bad_request": "არასწორი მოთხოვნა",
        "invalid_credentials": "არასწორი სერთიფიკატები",
        "no_permission": "არ გაქვთ უფლებები",
        "resource_not_found":"რესურსი ვერ მოიძებნა",
        "server_error":"სერვერის შეცდომა",
        "network_error":"ქსელის შეცდომა",
        "generic":"ზოგადი შეცდომა",
        "fetching_countries":"ქვეყნების ჩამონათვალის მიღებისას მოხდა შეცდომა",
        "email_exists":"ელფოსტის მისამართი უკვე არსებობს",
      },
      validation:{
        "email_required":"ელფოსტის მისამართი აუცილებელია",
        "password_required":"პაროლი აუცილებელია",
        "first_name_required":"სახელი აუცილებელია",
        "last_name_required":"გვარი აუცილებელია",
        "confirm_password_required":"პაროლის დადასტურება აუცილებელია",
        "phone_required":"ტელეფონის ნომერი აუცილებელია",
        "country_required":"ქვეყანა აუცილებელია",
        "personal_number_required":"საჭიროა პირადი ნომერი",
        "birthdate_required":"საჭიროა დაბადების თარიღი",
        "social_media_required":"საჭიროა სოციალური მედიის ბმული",
        "password_mismatch":"პაროლები არ ემთხვევა",
        "password_complexity" :"პაროლის არ აკმაყოფილებს სირთულის მოთხოვნებს",
        "social_media_format":"სოციალური მედიის ბმული უნდა იყოს ვალიდური URL",
        "age_requirement" :"თქვენ უნდა იყოთ მინიმუმ 18 წლის ან მეტის",
        "personal_number_format":"პირადი ნომერი უნდა შეიცავდეს 11 ციფრს",
        "personal_number_format_non_georgia":"პირადი ნომერი უნდა შეიცავდეს 7-ზე მეტ სიმბოლოს",
        "phone_format_invalid": "ტელეფონის ფორმატი არასწორია",
        "invalid_email":"არასწორი ელფოსტის ფორმატი",
        "social_media_invalid_url": "სოციალური მედიის ბმული არასწორია",

      },
      "success":{
        "registration":"რეგისტრაცია წარმატებით დასრულდა",
      },
      "auth":{
        "login_title":"შესვლა",
        "public_profile_info":"თქვენი პროფილი უნდა იყოს საჯარო",
        "email_label":"ელფოსტა",
        "email_placeholder":"user@example.com",
        "password_label":"პაროლი",
        "sign_in":"შესვლა",
        "no_account":"არ გაქვთ ანგარიში?",
        "register_here":"დარეგისტრირდი",
        "forgot_password":"დაგავიწყდათ პაროლი?",
        "reset_here":"პაროლის განახლება",
        "first_name":"სახელი",
        "last_name":"გვარი",
        "confirm_password":"დაადასტურეთ პაროლი",
        "personal_number":"პირადი ნომერი",
        "birthdate":"დაბადების თარიღი",
        "social_media_link":"სოციალური მედიის ბმული",
        "country":"ქვეყანა",
        "select_country":"აირჩიეთ ქვეყანა",
        "phone_number":"ტელეფონის ნომერი",
        "select_code":"აირჩიეთ კოდი",
        "phone_placeholder":"+995 599 12 34 56",
        "register":"რეგისტრაცია",
        "already_have_account":"გაქვთ ანგარიში?",
        "login_here":"შესვლა",
        "reset_password":"პაროლის აღდგენა",
        "remembered":"გაგახსენდათ პაროლი?",
        "social_media_profile_link":"პროფილი უნდა იყოს საჯარო",
        "passwords_match" :"პაროლები ემთხვევა",
        "passwords_do_not_match":"პაროლები არ ემთხვევა",
        "personal_number_placeholder_georgia": "შეიყვანეთ პირადი ნომერი",
        "personal_number_placeholder_non_georgia": "შეიყვანეთ პასპორტის/პირადი ნომერი",
      },
      "password_rules":{
        "length":"პაროლი უნდა შეიცავდეს მინიმუმ 8 სიმბოლოს",
        "uppercase":"პაროლი უნდა შეიცავდეს მინიმუმ ერთ დიდ ასოს",
        "lowercase":"პაროლი უნდა შეიცავდეს მინიმუმ ერთ პატარა ასოს",
        "special":"პაროლი უნდა შეიცავდეს მინიმუმ ერთ სპეციალურ სიმბოლოს",
      },
      "cart":{
        "cart":"კალათა",
        "item_price_label":"ფასი",
        "cart_empty":"თქვენი კალათა ცარიელია",
        "order_summary": "შეკვეთის მიმოხილვა",
    "subtotal": "ჯამური",
    "estimated_total": "საბოლოო ფასი",
    "checkout": "გადახდა",
    "discount": "ფასდაკლება",
    "update_cart": "კალათის განახლება",
    "enter_discount_code": "შეიყვანეთ ფასდაკლების კოდი",
    "terms_and_conditions": "მე ვეთანხმები",
        "terms_and_conditions_2": "კლუბის წესებს და პირობებს",
      },
  "QRscan":{
    "ticket_qr_scanner": "QR კოდის სკანერი",
    "select_decision": "აირჩიეთ გადაწყვეტილება",
    "accept": "მიღებულია",
    "reject": "უარყოფილია",
    "scanning_for_qr_code": "სკანირდება QR კოდი...",
    "scan_again": "ხელახლა სკანირება",
    "fetching_user_info": "მომხმარებლის ინფორმაციის იტვირთება...",
    "accepted": "მიღებულია",
    "rejected": "უარყოფილია",


  },
  "status": {
    "verified": "ვერიფიცირებული",
    "rejected": "უარყოფილია",
    "pending": "დაელოდეთ ვერიფიკაციას",
    "unverified": "არავერიფიცირებული",
    "check_later": "მოგვიანებით შეამოწმეთ" 
    }
  }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: "en", // default language
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18n;
